import { Box, Button, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import { AccountBalanceWallet, LocalPizza } from "@mui/icons-material";
import { useMemo } from "react";
import { IProgramaFidelidade } from "../../../promocoes/interfaces/IProgramaFidelidade";
import { IClienteProgramaFidelidade } from "../../../clientes/interface/IClienteProgramaFidelidade";
import { ICupom } from "../../interface/ICupom";
import { useMoeda } from "../../../core/hooks/useMoeda";
import { TipoProgramaFidelidade } from "../../../promocoes/enum/TipoProgramaFidelidade";
import { useResgateFidelidade } from "../../../promocoes/hooks/useResgateFidelidade";
import { ICategoria } from "../../../produtos/interfaces/ICategoria";
import { FidelidadeCashbackCard } from "./containers/FidelidadeCashbackCard";
import { FidelidadeItensCard } from "./containers/FidelidadeItensCard";
import { IProdutoPedido } from "../../interface/IProdutoPedido";

interface FidelidadeCardsProps {
    programasAtivos: IProgramaFidelidade[];
    programasCliente: IClienteProgramaFidelidade[];
    cupons: ICupom[];
    aplicarCupom: (cupom: ICupom) => Promise<void>;
    adicionarProduto: (produto: IProdutoPedido) => Promise<IProdutoPedido | undefined>;
    categorias: ICategoria[];
    produtos: IProdutoPedido[];
}

export const FidelidadeCards = ({
    programasAtivos,
    programasCliente,
    cupons,
    aplicarCupom,
    categorias,
    adicionarProduto,
    produtos,
}: FidelidadeCardsProps) => {
    const programasDisponiveis = useMemo(() => {
        return programasCliente
            .filter((programaCliente) => {
                const programaAtivo = programasAtivos.find(
                    (p) => p.uuid === programaCliente.programaFidelidadeUuid && p.ativo
                );
                return !!programaAtivo;
            })
            .map((programaCliente) => {
                const programaAtivo = programasAtivos.find(
                    (p) => p.uuid === programaCliente.programaFidelidadeUuid
                );
                return { programaCliente, programaAtivo: programaAtivo! };
            });
    }, [programasAtivos, programasCliente]);

    if (programasDisponiveis.length === 0) return null;

    return (
        <Box sx={{ width: "100%", marginTop: "1rem" }}>
            <Typography
                sx={{
                    fontSize: 11,
                    color: "grey.500",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    marginBottom: "12px",
                    fontFamily: "Poppins, sans-serif",
                }}
            >
                FIDELIDADE
            </Typography>

            <Stack spacing={2}>
                {programasDisponiveis.map(({ programaCliente, programaAtivo }) => {
                    if (programaAtivo.tipo === TipoProgramaFidelidade.CASHBACK) {
                        return <FidelidadeCashbackCard 
                            programaAtivo={programaAtivo}
                            programaCliente={programaCliente}
                            cupons={cupons}
                            aplicarCupom={aplicarCupom}
                            adicionarProduto={adicionarProduto}
                            categorias={categorias}
                            produtos={produtos}
                        />
                    } else if (programaAtivo.tipo === TipoProgramaFidelidade.ITENS) {
                        return <FidelidadeItensCard 
                            programaAtivo={programaAtivo}
                            programaCliente={programaCliente}
                            cupons={cupons}
                            aplicarCupom={aplicarCupom}
                            adicionarProduto={adicionarProduto}
                            categorias={categorias}
                            produtos={produtos}
                        />
                    }
                    return null;
                })}
            </Stack>
        </Box>
    );
};
